
import React from 'react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { getLocaleInfo } from '@/utils/localeUtils';
import { useTranslationContext } from '@/contexts/TranslationContext';

const LanguageSelector = () => {
  const { locale, setLocale, availableLocales } = useTranslationContext();
  const { t } = useTranslation();
  const currentLocale = getLocaleInfo(locale);

  // Don't render anything if there's only one locale
  if (availableLocales.length <= 1) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon" 
          className="flex items-center justify-center gap-2 min-w-[40px]"
        >
          <span className="text-lg">{currentLocale.flag}</span>
          <span className="sr-only">Switch language</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[150px]">
        {availableLocales.map((localeOption) => {
          const localeInfo = getLocaleInfo(localeOption);
          return (
            <DropdownMenuItem
              key={localeOption}
              onClick={() => setLocale(localeOption)}
              className="flex items-center gap-2 cursor-pointer"
            >
              <span className="text-lg">{localeInfo.flag}</span>
              <span className={locale === localeOption ? "font-bold" : ""}>
                {localeInfo.displayName}
              </span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
